import React from 'react';

const PostSkeleton = () => {
  return (
    <div className="bg-card rounded-xl lg:rounded-2xl p-5 md:p-6 lg:p-8 shadow-sm animate-pulse">
      <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-5">
        <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-muted rounded-full flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="h-4 bg-muted rounded w-32 md:w-40" />
        </div>
      </div>
      <div className="space-y-3 mb-5 md:mb-6 lg:mb-8">
        <div className="h-4 bg-muted rounded w-full" />
        <div className="h-4 bg-muted rounded w-11/12" />
        <div className="h-4 bg-muted rounded w-4/5" />
      </div>
      <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
        {[1, 2, 3]?.map((i) => (
          <div 
            key={i}
            className="h-12 md:h-14 lg:h-16 bg-muted rounded-lg lg:rounded-xl flex-1 sm:flex-initial sm:min-w-[140px] md:min-w-[160px]"
          />
        ))}
      </div>
    </div>
  );
};

export default PostSkeleton;